import React, { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { bakeStreetLogo } from "../../common/constants";
import moment from "moment";
import { Alert } from "@mui/material";
import { capitalize, formatPhoneNumber, getCustomerName, getStartTime } from "../../common/util";
import { UserContext } from "../../context/UserContext";
import HTMLViewer from "../../common/component/HTMLViewer";
import OrderPrintLineItems from "./print/OrderPrintLineItems";
import UserAvatar from "../../common/UserAvatar";

export default function OrderPrintVersion(props) {
  const { user } = useContext(UserContext);
  const { type } = props;

  const { customer, fulfillment, kitchen, invoice, items } = props.order;
  const customerName = getCustomerName(customer);

  let readyByTime = fulfillment.time || "";
  if (user.acctId === "RaKfruZdNNMhNqd0ZF65" || user.acctId === "-MX2oaNrh4TcKVvnhcT9") {
    const startHour = getStartTime(fulfillment.time);
    if (startHour > 0) {
      let fulfillmentHour = startHour - 1;
      if (moment(fulfillment.date).isoWeekday() === 6) {
        // override for Saturday
        fulfillmentHour = startHour - 3;
      }
      readyByTime = `${fulfillmentHour % 12 || 12}${fulfillmentHour < 12 ? "am" : "pm"}`;
    }
  }

  let alert = (
    <Box sx={{ marginBottomL: "5pt" }}>
      <Box>
        <Alert severity="error">
          Verify order details and collect any balance payment before pick up / delivery.
        </Alert>
      </Box>
    </Box>
  );

  const header = (
    <Box sx={{ marginBottom: "10pt" }}>
      <Box sx={{ borderBottom: "1pt solid #DDD", paddingBottom: "5pt" }}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={3}>
            <Typography variant="h6">{customerName}</Typography>
            <Typography variant="body1">{formatPhoneNumber(customer.phone)}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h6">{`${moment(fulfillment.date).format("ddd, MMM D")} `}</Typography>
            <Typography variant="body1">{readyByTime}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h6">{capitalize(fulfillment.type)}</Typography>
            {fulfillment.type === "pickup" && (
              <Box>
                <Typography variant="body1">
                  {fulfillment.location?.street || fulfillment.address?.split(",")[0]}
                </Typography>
                <Typography variant="body1">
                  {fulfillment.location
                    ? `${fulfillment.location.city}, ${fulfillment.location.state}`
                    : ""}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid item xs={3} align="right">
            <Box>
              <img
                alt="logo"
                src={bakeStreetLogo}
                style={{ maxHeight: "16pt", marginBottom: "3pt" }}
              ></img>
            </Box>
            <UserAvatar uid={props.order.uid} style={{ width: "32px", height: "32px" }} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );

  let chromeAgent = window.navigator.userAgent.indexOf("Chrome") > -1;
  let safariAgent = window.navigator.userAgent.indexOf("Safari") > -1;
  if (chromeAgent && safariAgent) {
    safariAgent = false;
  }

  const kitchenInstructions = (
    <Box>
      {kitchen && (
        <Box mt={1} py={1} sx={{ borderTop: "1px solid #DDD" }}>
          <Typography variant="overline" color="textSecondary">
            INSTRUCTIONS
          </Typography>
          <HTMLViewer content={kitchen.notes} style={{ fontSize: "1rem" }} />
        </Box>
      )}
    </Box>
  );

  const footer = (
    <Box align="center" sx={{ borderTop: "1pt solid #DDD", paddingTop: "5pt", marginTop: "5pt" }}>
      <Typography variant="overline" color="textSecondary">
        {customerName} ● {moment(fulfillment.date).format("ddd, MMM D")} [{readyByTime}] ●{" "}
        {capitalize(fulfillment.type)}
      </Typography>
    </Box>
  );

  if (props.order.items) {
    return (
      <Box>
        {type === "compact" && (
          <Box>
            <div style={{ height: "9in" }}>
              {header}
              {alert}
              <OrderPrintLineItems items={items} type={type} />
              {kitchenInstructions}
            </div>
            {footer}
          </Box>
        )}
        {type === "expanded" &&
          items.map((item, idx) => {
            return (
              <Box key={idx}>
                {idx > 0 && <div class="pagebreak"> </div>}
                <div style={{ height: "9in" }}>
                  <Box style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    {header}
                    {alert}
                    <Box
                      p={1}
                      align="center"
                      style={{ flexGrow: "1", overflow: "hidden", height: "100%" }}
                    >
                      <Box sx={{ display: "flex", height: "100%" }}>
                        {item.images &&
                          item.images.length > 0 &&
                          item.images.map((o, idx) => {
                            return (
                              <Box
                                sx={{
                                  maxWidth: `${Number(100 / item.images.length)}%`,
                                  maxHeight: "100%",
                                }}
                              >
                                <img
                                  src={o}
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                />
                              </Box>
                            );
                          })}
                        {(!item.images || item.images.length === 0) && (
                          <img
                            src={``}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        )}
                      </Box>
                    </Box>
                    <OrderPrintLineItems items={[item]} type={type} />
                    {kitchenInstructions}
                  </Box>
                </div>
                {footer}
                {/*item.images &&
                  item.images.map((o, idx) => {
                    return (
                      <Box>
                        <div class="pagebreak"> </div>
                        <div style={{ height: "9in" }}>
                          <Box key={idx} style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <Box>{header}</Box>
                            <Box p={1} align="center" style={{ flexGrow: "1", overflow: "hidden", height: "100%" }}>
                              <img
                                src={o}
                                style={{ height: "100%", maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: "4px" }}
                              />
                            </Box>
                          </Box>
                        </div>
                        {footer}
                      </Box>
                    );
                  })*/}
              </Box>
            );
          })}
      </Box>
    );
  }
}
